export const GET_PODCAST_LIST_DATA_INIT = 'GET_PODCAST_LIST_DATA_INIT'
export const GET_PODCAST_LIST_DATA_SUCCESS = 'GET_PODCAST_LIST_DATA_SUCCESS'
export const GET_PODCAST_LIST_DATA_FAIL = 'GET_PODCAST_LIST_DATA_FAIL'

export const GET_PODCAST_DETAILS_INIT = 'GET_PODCAST_DETAILS_INIT'
export const GET_PODCAST_DETAILS_SUCCESS = 'GET_PODCAST_DETAILS_SUCCESS'
export const GET_PODCAST_DETAILS_FAIL = 'GET_PODCAST_DETAILS_FAIL'
